module.exports = __webpack_public_path__ + "static/360-bg-945d5f5cc94f82e8821901a8e2a69a8d.png";